import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/PageLayout/PageLayout.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/page-layout/react/latest'} mdxType="DeprecationBanner" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {PageLayout} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <Note mdxType="Note">
      <p>{`See `}<a parentName="p" {...{
          "href": "https://primer.style/react/storybook?path=/story/components-pagelayout"
        }}>{`storybook`}</a>{` for fullscreen examples.`}</p>
    </Note>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header>
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With dividers`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header divider="line">
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  {/* You can change the divider based on the viewport width */}
  <PageLayout.Pane divider={{narrow: 'line'}}>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer divider="line">
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With connected dividers`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout padding="none" rowGap="none" columnGap="none">
  <PageLayout.Header padding="normal" divider="line">
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content padding="normal">
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane padding="normal" divider="line">
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer padding="normal" divider="line">
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With pane on left`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header>
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane position="start">
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With pane hidden on narrow viewports`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header>
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane position="start" hidden={{narrow: true}}>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With condensed spacing`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout padding="condensed" rowGap="condensed" columnGap="condensed">
  <PageLayout.Header>
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`Without header or footer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
</PageLayout>
`}</code></pre>
    <h3>{`With a sticky pane`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <PageLayout>
    <PageLayout.Header>
      <Placeholder label="Header" height={64} />
    </PageLayout.Header>
    <PageLayout.Content>
      <Placeholder label="Content" height={420} />
    </PageLayout.Content>
    <PageLayout.Pane sticky>
      <Placeholder label="Pane" height={120} />
    </PageLayout.Pane>
    <PageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </PageLayout.Footer>
  </PageLayout>
</Box>
`}</code></pre>
    <h3>{`With a custom sticky header`}</h3>
    <p>{`Add `}<inlineCode parentName="p">{`offsetHeader`}</inlineCode>{` prop to specify the height of the custom sticky header along with `}<inlineCode parentName="p">{`sticky`}</inlineCode>{` prop`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <Box
    sx={{
      position: 'sticky',
      top: 0,
      height: 64,
      display: 'grid',
      placeItems: 'center',
      backgroundColor: 'canvas.subtle',
      borderBottom: '1px solid',
      borderColor: 'border.default',
      zIndex: 1,
    }}
  >
    Custom sticky header
  </Box>
  <PageLayout>
    <PageLayout.Content>
      <Placeholder label="Content" height={320} />
    </PageLayout.Content>
    <PageLayout.Pane position="start" sticky offsetHeader={64}>
      <Placeholder label="Pane" height={120} />
    </PageLayout.Pane>
    <PageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </PageLayout.Footer>
  </PageLayout>
</Box>
`}</code></pre>
    <h3>{`With `}<inlineCode parentName="h3">{`NavList`}</inlineCode></h3>
    <p><inlineCode parentName="p">{`PageLayout.Pane`}</inlineCode>{` by itself does not specify or provide landmark roles. Using
components that define their own landmark roles, such as `}<a parentName="p" {...{
        "href": "/NavList"
      }}><inlineCode parentName="a">{`NavList`}</inlineCode></a>{`, will provide
clear structure to the page that is not present by default in `}<inlineCode parentName="p">{`PageLayout.Pane`}</inlineCode>{`.`}</p>
    <p>{`It's important to note that multiple landmark roles, such as multiple
`}<inlineCode parentName="p">{`<nav>`}</inlineCode>{` elements, should be uniquely labelled in order to clarify what the
navigation container is used for.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header>
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Pane position="start" aria-label="Secondary navigation">
    <NavList>
      <NavList.Item href="/" aria-current="page">
        Home
      </NavList.Item>
      <NavList.Item href="/about">About</NavList.Item>
      <NavList.Item href="/contact">Contact</NavList.Item>
    </NavList>
  </PageLayout.Pane>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With `}<inlineCode parentName="h3">{`aria-label`}</inlineCode></h3>
    <p>{`Using `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` along with `}<inlineCode parentName="p">{`PageLayout.Header`}</inlineCode>{` or `}<inlineCode parentName="p">{`PageLayout.Footer`}</inlineCode>{` creates a unique label for that landmark role that can make it easier to navigate between sections of content on a page.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header aria-label="Header">
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer aria-label="Footer">
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With `}<inlineCode parentName="h3">{`aria-labelledby`}</inlineCode></h3>
    <p>{`Using `}<inlineCode parentName="p">{`aria-labelledby`}</inlineCode>{` along with `}<inlineCode parentName="p">{`PageLayout.Header`}</inlineCode>{` or `}<inlineCode parentName="p">{`PageLayout.Footer`}</inlineCode>{` creates a unique label for each landmark role by using the given `}<inlineCode parentName="p">{`id`}</inlineCode>{` to associate the landmark with the content with the corresponding `}<inlineCode parentName="p">{`id`}</inlineCode>{`. This is helpful when you have a visible item that visually communicates the type of content which you would like to associate to the landmark itself.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header aria-labelledby="header-label">
    <Placeholder id="header-label" label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer aria-labelledby="footer-label">
    <Placeholder id="footer-label" label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With resizable pane`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header>
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane resizable>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With `}<inlineCode parentName="h3">{`<main>`}</inlineCode>{` landmark`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header>
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <main>
      <Placeholder label="Content" height={240} />
    </main>
  </PageLayout.Content>
  <PageLayout.Pane resizable>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h2>{`Accessibility`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`PageLayout`}</inlineCode>{` component uses `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/landmark_role"
      }}>{`landmark roles`}</a>{` for `}<inlineCode parentName="p">{`PageLayout.Header`}</inlineCode>{` and `}<inlineCode parentName="p">{`PageLayout.Footer`}</inlineCode>{` in order to make it easier for screen reader users to navigate between sections of the page.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Component`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Landmark role`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PageLayout.Header`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/banner_role"
            }}><inlineCode parentName="a">{`banner`}</inlineCode></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PageLayout.Footer`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/contentinfo_role"
            }}><inlineCode parentName="a">{`contentinfo`}</inlineCode></a></td>
        </tr>
      </tbody>
    </table>
    <p>{`Each component may be labeled through either `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` or `}<inlineCode parentName="p">{`aria-labelledby`}</inlineCode>{` in order to provide a unique label for the landmark. This can be helpful when there are multiple landmarks of the same type on the page.`}</p>
    <h3>{`Links & Resources`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://w3c.github.io/aria/#landmark_roles"
        }}>{`W3C, Landmark roles`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/WAI/WCAG22/Techniques/aria/ARIA11"
        }}>{`WCAG, ARIA11 Technique`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/landmark_role"
        }}>{`MDN, Landmark roles`}</a></li>
    </ul>
    <h3><inlineCode parentName="h3">{`PageLayout.Content`}</inlineCode>{` as landmark`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`PageLayout.Content`}</inlineCode>{` component does not provide a default `}<inlineCode parentName="p">{`<main>`}</inlineCode>{` landmark role.
If you want to utilize a `}<inlineCode parentName="p">{`<main>`}</inlineCode>{` landmark with this component, you may supply one directly `}<a parentName="p" {...{
        "href": "#with-main-landmark"
      }}>{`as a child of `}<inlineCode parentName="a">{`PageLayout.Content`}</inlineCode></a>{`.
When using `}<inlineCode parentName="p">{`<main>`}</inlineCode>{` ensure that no other `}<inlineCode parentName="p">{`<main>`}</inlineCode>{` landmark exists on the page, as there should only be one per page.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/WAI/ARIA/apg/patterns/landmarks/examples/main.html"
        }}><inlineCode parentName="a">{`main`}</inlineCode>{` landmark usage`}</a></li>
    </ul>
    <h3><inlineCode parentName="h3">{`PageLayout.Pane`}</inlineCode>{` as landmark`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`PageLayout.Pane`}</inlineCode>{` component does not provide a default landmark role as the
content of this component may have different roles. When using this component,
consider the type of content being rendered inside of `}<inlineCode parentName="p">{`PageLayout.Pane`}</inlineCode>{` and if
it requires a landmark role. Common landmark roles include:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/aside"
        }}><inlineCode parentName="a">{`aside`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/aside"
        }}><inlineCode parentName="a">{`navigation`}</inlineCode></a></li>
    </ul>
    <p>{`Some components, such as `}<inlineCode parentName="p">{`NavList`}</inlineCode>{` may already include a landmark role. In these
situation, these components use an appropriate landmark role and no further
action is needed when using `}<inlineCode parentName="p">{`PageLayout.Pane`}</inlineCode>{`.`}</p>
    <h3>{`Screen readers`}</h3>
    <p>{`Most screen readers provide a mechanism through which you can navigate between landmarks on the page. Typically, this is done through a specific keyboard shortcut or through an option in a rotor.`}</p>
    <h4>{`JAWS`}</h4>
    <p>{`JAWS supports landmark regions and the details in which it presents them depends on the Web Verbosity Level setting. You can navigate to the next landmark on the page by pressing `}<inlineCode parentName="p">{`R`}</inlineCode>{` and the previous landmark by pressing `}<inlineCode parentName="p">{`Shift-R`}</inlineCode>{`.`}</p>
    <h4>{`NVDA`}</h4>
    <p>{`NVDA supports landmark regions and you can navigate to the next landmark by using pressing `}<inlineCode parentName="p">{`D`}</inlineCode>{` and to the previous landmark by pressing `}<inlineCode parentName="p">{`Shift-D`}</inlineCode>{`. You may also list out the landmarks by pressing `}<inlineCode parentName="p">{`Insert-F7`}</inlineCode>{`.`}</p>
    <h4>{`VoiceOver`}</h4>
    <p>{`VoiceOver supports `}<a parentName="p" {...{
        "href": "https://support.apple.com/guide/voiceover/by-landmarks-vo35709/mac"
      }}>{`assigning landmark roles`}</a>{` to areas of a page. In order to navigate between landmarks, you can use the `}<a parentName="p" {...{
        "href": "https://support.apple.com/guide/voiceover/with-the-voiceover-rotor-mchlp2719/10/mac/12.0"
      }}>{`rotor`}</a>{`.`}</p>
    <p>{`On macOS, you can open the VoiceOver rotor by pressing `}<inlineCode parentName="p">{`VO-U`}</inlineCode>{`. You can navigate between lists to find the `}<inlineCode parentName="p">{`Landmarks`}</inlineCode>{` list by using the Right Arrow or Left Arrow key. From that list, you can use the Down Arrow and Up Arrow keys to navigate between landmarks identified on the page.`}</p>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      